import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const DroneRacingLeague = ({featuredProjectsList}) => {
  const project = getProject('drone-racing-league');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '420017014'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            When the founders of DRL asked us to create the brand identity and
            website for their new drone racing concept, they had us at “drone”
            and “racing”.
          </p>
          <p>It was something we had to be a part of.</p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170724121945/Logo_alt1.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="process">Process</h2>
          <p>
            The creation of a new brand identity established the foundation for
            a module-based website that could scale with the rapid growth of the
            company — allowing the content team to quickly pivot; create,
            update, and delete modules or entire pages with minimal effort.
          </p>
       </AnimateIn>

        <Image
          component={{
            image:
              '//images.yourmajesty.co/20170804144551/Introduction_alt3.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170804144549/Introduction_alt1.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170804144554/Video.jpg'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20170724122012/Pr_Alt2.png'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Since they officially launched in early 2016 DRL has grown from
            being a few guys with a passion into a multinational racing circus
            with millions of fans and official races all over the world. 
         </p>
         <p>
          We’re proud to have helped them take off by creating the DRL 
          brand identity and the first version of the online presence.
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Collaborative Working Sessions',
                  'Content Strategy',
                  'Experience Mapping',
                  'Interviews & User Testing',
                  'Prototyping & Validation',
                  'Research',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Brand Design',
                  'Creative Direction',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping',
                  'WebGL'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Analytics & Insights',
                  'Integration Support',
                  'Launch',
                  'Monitoring',
                  'Optimization',
                  'Quality Assurance',
                  'Staff Training & Support'
                ]
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'http://www.drl.io/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default DroneRacingLeague;
